import React from "react";
import { Table, Button, Switch, Input, Tooltip } from "antd";
import { CiSearch } from "react-icons/ci";

const { Search } = Input;

const PaymentMonitoring = () => {
  const data = Array.from({ length: 12 }).map((_, i) => ({
    key: i,
    date: i % 2 === 0 ? "09/06/2025" : "09/08/2025",
    time: i % 2 === 0 ? "09:00" : "14:00",
    tenantName: "John Edwin",
    unitId: "ID 1021",
    method: "Email",
    type: i % 2 === 0 ? "Scheduled" : "Resend",
    content:
      "Your Rent Payment Reminder for the month of June. Please ensure timely payment to avoid late fees.",
  }));

  const columns = [
    {
      title: "Date Sent",
      dataIndex: "date",
      key: "date",
      render: (_, record) => `${record.date} ${record.time}`,
    },
    {
      title: "Tenant Name",
      dataIndex: "tenantName",
      key: "tenantName",
    },
    {
      title: "Unit ID / Name",
      dataIndex: "unitId",
      key: "unitId",
    },
    {
      title: "Notification Method",
      dataIndex: "method",
      key: "method",
    },
    {
      title: "Notification Type",
      dataIndex: "type",
      key: "type",
      render: (text) => (
        <span
          className={`${
            text === "Scheduled" ? "text-[#C46500]" : "text-[#07C01D]"
          } font-[400] leading-6 text-[12px] font-inter tracking-[0%]`}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Content Preview",
      dataIndex: "content",
      key: "content",
      render: (text) => (
        <Tooltip
          title={
            <div className="text-center font-sans text-[13px] font-normal leading-[20px] text-[#4E4E4E] max-w-[199px]  whitespace-pre-line">
              {text}
            </div>
          }
          overlayClassName="custom-tooltip-wrapper"
          placement="top"
          arrow={true}
        >
          <span className="inline-block max-w-[120px] truncate cursor-pointer">
            {text}
          </span>
        </Tooltip>
      ),
    },
    {
      title: "Actions",
      key: "action",
      render: () => (
        <Button
          type="default"
          className="border-[#4772F1] text-[#4772F1] leading-6 rounded-[15px] h-[28px] px-3 py-[2px] text-[9px] sm:text-[10px] md:text-[11px] lg:text-[12px] font-[400]"
        >
          Send Notification
        </Button>
      ),
    },
  ];

  return (
    <div className="bg-diagonal-sky min-h-screen p-4 sm:p-6 md:p-[30px]">
      <div className="  ">
        <div className="flex flex-wrap items-center justify-between mb-[30px] h-auto md:h-[107px] bg-white px-[30px] py-[31px] rounded-[10px] gap-4">
          <div className="flex flex-col sm:flex-row lg:flex-row items-start sm:items-center justify-between gap-4 w-full">
            <div className="flex items-center gap-[15px] w-full max-w-[525px]">
              <div className="flex items-center border border-[#81818180] rounded-[5px] overflow-hidden w-full lg:w-[427px] h-10 sm:h-[45px]">
                <CiSearch className="ml-4 w-[22px] h-[22px] text-[#4A4A4A]" />
                <input
                  type="text"
                  placeholder="Search by tenant name or unit ID"
                  className="w-full h-full pl-3 pr-4 text-[9px] sm:text-[11px] md:text-[13px] lg:text-[15px] leading-[100%] tracking-[0%] font-inter font-normal text-[#9D9D9D] outline-none "
                  style={{ border: "none", backgroundColor: "transparent" }}
                />
              </div>
              <button
                type="button"
                className="h-10 sm:h-[45px] px-4 w-[83px] border border-[#873FE2B0] bg-[#873FE2] text-white text-[9px] sm:text-[10px] md:text-[11px] lg:text-[12px] font-[500] font-inter leading-[100%] tracking-[0%] rounded-[3.77px] hover:brightness-110 transition-all"
              >
                SEARCH
              </button>
            </div>

            <div className="flex  border border-[#CECECE] py-[10px] px-3 rounded-[5px] h-10 sm:h-[45px] w-full [@media(min-width:400px)]:w-[242px] items-center justify-between gap-2">
              <span className="text-[9px] sm:text-[11px] md:text-[13px] lg:text-[15px] text-[#9D9D9D] font-normal font-inter leading-[100%] tracking-[0%]">
                Auto-Reminders
              </span>
              <Switch className="" />
            </div>
          </div>
        </div>

        <div className="overflow-x-auto">
          <div className="min-w-[1224px]">
            <Table
              columns={columns}
              dataSource={data}
              pagination={false}
              bordered={false}
              className="notification-table"
              components={{
                header: {
                  cell: (props) => (
                    <th
                      {...props}
                      className="bg-gradient-to-b from-[#E5F0FF2D] to-[#873FE214] text-[#4772F1] text-[10px] sm:text-[12px] md:text-[13px] lg:text-[14px] font-bold font-inter px-[30px] py-[12px] border-b border-[#eee] whitespace-nowrap leading-[22px]"
                      style={{
                        background:
                          "linear-gradient(180deg, rgba(229, 240, 255, 0.1764) 0%, rgba(135, 63, 226, 0.0784) 100%)",
                        color: "#4772F1",
                        //  fontSize: "14px",
                        fontWeight: 700,
                        fontFamily: "Inter",
                        padding: "12px 30px",
                        borderBottom: "1px solid #eee",
                        whiteSpace: "nowrap",
                        lineHeight: "22px",
                      }}
                    />
                  ),
                },
                body: {
                  cell: (props) => (
                    <td
                      {...props}
                      className="text-[#707070] text-[10px] sm:text-[12px] md:text-[13px] lg:text-[14px] font-inter font-normal px-[30px] py-[12px] border-b border-[#f0f0f0] whitespace-nowrap leading-[22px]"
                      style={{
                        padding: "12px 30px",
                        // fontSize: "14px",
                        fontWeight: 400,
                        lineHeight: "22px",
                        letterSpacing: "0",
                        color: "#707070",
                        fontFamily: "Inter",
                        borderBottom: "1px solid #f0f0f0",
                        whiteSpace: "nowrap",
                      }}
                    />
                  ),
                },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentMonitoring;
